import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "error ion-padding"
}
const _hoisted_4 = {
  key: 1,
  class: "error ion-padding"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "basic-login-text" }, "Passwort vergessen", -1)
const _hoisted_6 = {
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { class: "link-text-color" }, "Melde dich an", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { class: "link-text-color" }, " Login", -1)
const _hoisted_13 = { style: {"margin":"auto","text-align":"center"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"pointer"},
  class: "ion-color-medium"
}, "Datenschutz", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "AGB", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "Impressum", -1)
const _hoisted_19 = { style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"7px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_success_animation = _resolveComponent("login-success-animation")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_mobility_logo = _resolveComponent("mobility-logo")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          (!$setup.showSuccessMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString($setup.forgotPasswordTitle), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("form", {
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.forgotPassword && $setup.forgotPassword(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_ion_card, { class: "ion-no-padding ion-no-margin" }, {
                      default: _withCtx(() => [
                        ($setup.nameError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.nameError), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { position: "stacked" }, {
                              default: _withCtx(() => [
                                _createTextVNode("E-Mail")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_input, {
                              modelValue: $setup.forgotPasswordData.email,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.forgotPasswordData.email) = $event)),
                              placeholder: "E-Mail",
                              type: "email",
                              autocomplete: "email",
                              required: "true",
                              tabindex: "2",
                              onKeyup: _withKeys($setup.forgotPassword, ["enter"])
                            }, null, 8, ["modelValue", "onKeyup"])
                          ]),
                          _: 1
                        }),
                        ($setup.emailError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.emailError), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          class: "basic-login-btn",
                          expand: "block",
                          type: "submit",
                          style: {"min-height":"65px","margin-bottom":"-5px","margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, [
                    _createTextVNode("Bereits registriert? "),
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.showSuccessMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h1", { innerHTML: $setup.registerSuccessTitle }, null, 8, _hoisted_10),
                  _createVNode(_component_login_success_animation, { style: {"max-height":"30rem","width":"100%"} }),
                  _createElementVNode("p", {
                    innerHTML: $setup.getRegisterSuccessBody()
                  }, null, 8, _hoisted_11),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.registerGoBackTo) + " ", 1),
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!$setup.showSuccessMessage)
        ? (_openBlock(), _createBlock(_component_ion_footer, {
            key: 0,
            class: "ion-padding"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/privacy-crudafoch" }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_15,
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/terms" }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_17,
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/impress" }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("p", _hoisted_19, " Version: " + _toDisplayString($setup.appVersion), 1),
              _createVNode(_component_mobility_logo)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}